import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import moment from 'moment';
import { useMemo } from 'react';
import { EGG_COLOUR, TRAP_CATCH_COLOUR } from '../../utils';

const G2MonitoringChart = ({ trapCatchData, eggData }) => {
  const options = useMemo(() => {
    const toSeriesData = (data) =>
      data
        .map((d) => [moment(d.date).valueOf(), d.amount])
        .sort((a, b) => a[0] - b[0]);

    return {
      chart: {
        type: 'line'
      },
      credits: {
        enabled: false
      },
      title: {
        text: 'G2 Monitoring'
      },
      xAxis: {
        type: 'datetime',
        tickInterval: 2 * 7 * 24 * 3600 * 1000,
        gridLineWidth: 1,
        labels: {
          format: '{value:%e-%b}'
        }
      },
      yAxis: [
        {
          title: {
            text: 'Trap Catch (midges/trap)'
          }
        },
        {
          title: {
            text: 'Egg Monitoring (% infestation)'
          },
          min: 0,
          max: 100,
          opposite: true
        }
      ],
      legend: {
        enabled: true
      },
      plotOptions: {
        line: {
          marker: {
            enabled: true,
            symbol: 'circle'
          }
        }
      },
      series: [
        {
          name: 'Trap Catch (midges/trap)',
          data: toSeriesData(trapCatchData),
          color: TRAP_CATCH_COLOUR,
          tooltip: {
            valueDecimals: 0
          },
          yAxis: 0
        },
        {
          name: 'Egg Monitoring (% infestation)',
          data: toSeriesData(eggData),
          color: EGG_COLOUR,
          tooltip: {
            valueDecimals: 2
          },
          yAxis: 1
        }
      ]
    };
  }, [trapCatchData, eggData]);

  return <HighchartsReact highcharts={Highcharts} options={options} />;
};

export default G2MonitoringChart;

